"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.moveCanadaUsOnTop = exports.getRegionById = exports.getCountryById = exports.UNITED_STATES_COUNTRY_ID = exports.CANADA_COUNTRY_ID = void 0;
exports.CANADA_COUNTRY_ID = "CA";
exports.UNITED_STATES_COUNTRY_ID = "US";
Array.prototype.move = function (from, to) {
    this.splice(to, 0, this.splice(from, 1)[0]);
};
const getCountryById = (allCountries, countryId) => {
    return allCountries.find((country) => country.id === countryId);
};
exports.getCountryById = getCountryById;
const getRegionById = (country, regionId) => {
    var _a;
    return (_a = country.available_regions) === null || _a === void 0 ? void 0 : _a.find((region) => region.id === regionId);
};
exports.getRegionById = getRegionById;
const moveCanadaUsOnTop = (countriesSelect) => {
    ["US", "CA"].forEach((code) => {
        const codeIndex = countriesSelect.findIndex((option) => option.value == code);
        countriesSelect.move(codeIndex, 0);
    });
    return countriesSelect;
};
exports.moveCanadaUsOnTop = moveCanadaUsOnTop;
//# sourceMappingURL=countriesRegionsHelper.js.map